import { DataFilter } from '@siclop/kstone-vue'
import { ProjectStatus } from '../enums'

export class ProjectFilter extends DataFilter {
  code?: string
  name?: string
  customerId?: number
  projectState?: ProjectStatus
  startDateFrom?: Date
  startDateTo?: Date
  endDateFrom?: Date
  endDateTo?: Date
  gitLabProjectId?: number

  constructor(data?: Partial<ProjectFilter>) {
    super(data)
    if (data) {
      this.code = data.code
      this.name = data.name
      this.customerId = data.customerId
      this.projectState = data.projectState
      this.startDateFrom = data.startDateFrom
      this.startDateTo = data.startDateTo
      this.endDateFrom = data.endDateFrom
      this.endDateTo = data.endDateTo
      this.gitLabProjectId = data.gitLabProjectId
    }
  }

  override toQueryString(): string {
    let qs = super.toQueryString()
    const params: string[] = []

    if (this.code) {
      params.push(`Code=${encodeURIComponent(this.code)}`)
    }
    if (this.name) {
      params.push(`Name=${encodeURIComponent(this.name)}`)
    }
    if (this.customerId !== undefined) {
      params.push(`CustomerId=${this.customerId}`)
    }
    if (this.projectState !== undefined) {
      params.push(`ProjectState=${this.projectState}`)
    }
    if (this.startDateFrom) {
      params.push(`StartDateFrom=${this.startDateFrom.toISOString()}`)
    }
    if (this.startDateTo) {
      params.push(`StartDateTo=${this.startDateTo.toISOString()}`)
    }
    if (this.endDateFrom) {
      params.push(`EndDateFrom=${this.endDateFrom.toISOString()}`)
    }
    if (this.endDateTo) {
      params.push(`EndDateTo=${this.endDateTo.toISOString()}`)
    }
    if (this.gitLabProjectId !== undefined) {
      params.push(`GitLabProjectId=${this.gitLabProjectId}`)
    }

    if (params.length > 0) {
      qs += (qs ? '&' : '?') + params.join('&')
    }
    return qs
  }
}
